import { render, staticRenderFns } from "./BehaviouralInsights.vue?vue&type=template&id=b516be96&"
import script from "./BehaviouralInsights.vue?vue&type=script&lang=js&"
export * from "./BehaviouralInsights.vue?vue&type=script&lang=js&"
import style0 from "./BehaviouralInsights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports